import React from 'react'
import Image from 'next/image'
import { ArtistIntroCardType } from '~types'
import styles from './ArtistIntroCard.module.scss'
import { constructS3Url } from 'utils'
import { NEXT_IMAGE_QUALITY } from '~constants'

const ArtistIntroCard = ({ backgroundImage, logo, title, logoUrlS3, backgroundImageUrlS3 }: ArtistIntroCardType) => {
  return (
    <div className={styles.container}>
      <div className={styles['logo-title-container']}>
        {title && <div className={styles.title}>{title}</div>}
        {logoUrlS3 && (
          <div className={styles['logo-container']}>
            <Image alt="logo" src={constructS3Url(logoUrlS3)} fill quality={NEXT_IMAGE_QUALITY} />
          </div>
        )}
      </div>
      {backgroundImageUrlS3 && (
        <>
          <Image
            src={constructS3Url(backgroundImageUrlS3)}
            alt="" // @TODO: add alt when migrated back to Hygraph
            fill
            quality={NEXT_IMAGE_QUALITY}
          />
        </>
      )}
    </div>
  )
}

export default ArtistIntroCard
